import { useState } from "react";
import { Button } from "../../../../../../../components/ui/Buttons/Button/Button";
import { IconSvg } from "../../../../../../../utils/constants/icons/iconSvg.constant";
import { PlainTable } from "../../../../../../../components/ui/PlainTable/PlainTable";
import { useTranslation } from "../../../../../../../hooks";
import { AddIpModal } from "./components/RemoveIpModal/AddIpModal";
import { RemoveIpModal } from "./components/AddIpModal/RemoveIpModal";
import "./WhiteList.scss";

const data = [
  {
    ip: "148.22.225.64",
    listName: "",
    selected: false,
    action: "trash"
  },
  {
    ip: "148.22.225.64",
    listName: "Mix Europe",
    selected: true,
    action: "trash"
  }
];

export const WhiteList = () => {
  const [isAddIpOpen, setIsAddIpOpen] = useState(false);
  const [isRemoveIpOpen, setIsRemoveIpOpen] = useState(false);

  const { cabinet: { orders: { residential: {
    whiteListTitle, sub, addButton, noIp
  } } } } = useTranslation();

  return (
    <div className="white-list-wrapper">
      <div className="white-list">
        <div className="white-list__head">
          <div className="white-list__head-wrapper">
            <div className="white-list__title">{whiteListTitle}</div>
            <div className="white-list__label">{sub}</div>
          </div>
          <div className="white-list__add-button">
            <Button tab="gray-gradient" onClick={() => setIsAddIpOpen(true)}>
              <IconSvg tag="thinPlus" className="white-list__button-icon"/>
              <div className="white-list__button-text">{addButton}</div>
            </Button>
          </div>
        </div>
        {data.length ? (
          <PlainTable data={data} actionHandler={() => setIsRemoveIpOpen(true)} />
        ) : (
          <div className="white-list__no-data">
            <IconSvg tag="proxyListEmpty"/>
            <div className="white-list__no-data-text">{noIp}</div>
          </div>
        )}
        {isRemoveIpOpen && <RemoveIpModal onClose={() => setIsRemoveIpOpen(false)} />}
        {isAddIpOpen && <AddIpModal onClose={() => setIsAddIpOpen(false)} />}
      </div>
    </div>
  );
};
